<template>
    <div>
      <el-form ref="form" :rules="rules" :model="form" label-width="100px">
        <el-form-item label="留言者:" prop="name">
          <el-input v-model="form.name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱:" prop="email">
          <el-input v-model="form.email" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="留言内容:" prop="content">
          <el-input v-model="form.content" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="回复内容:">
          <el-input v-model="form.replycontent" type="textarea"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="onSubmit('form')">编辑</el-button>
        </el-form-item>
      </el-form>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      editID: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        form: {
          name: '',
          content: '',
          email: '',
          replycontent:''
        },
        rules: {
          name: [{ required: true, message: "友链名称不能为空", trigger: "blur" }],
          content: [{ required: true, message: "留言内容不能为空", trigger: "blur" }],
          email: [{ required: true, message: "邮箱不能为空", trigger: "blur" }],
        },
      };
    },
    methods: {
      onSubmit(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (!valid) {
            this.$message.error("编辑失败");
            return false;
          }
          if (this.editID > 0) {
            const { data: res } = await this.$axios.post(
              "/message/editMessage",
              this.form
            );
            console.log(res);
            if (res.meta.status !== 200) return this.$message.error(res.meta.msg);
            this.$emit("onDialog", false);
            return this.$message.success(res.meta.msg);
          } 
        });
      },
      async getMessage(id) {
        const { data: res } = await this.$axios.post("/message/getMessageId", {
          id: id,
        });
        console.log(res);
        this.form = res.data;
      },
    },
    created() {
      if (this.editID > 0) {
        console.log(this.editID);
        this.getMessage(this.editID);
      }
    },
  }
  </script>
  
  <style lang="less">
  .el-input,
  .el-textarea {
    max-width: 800px;
  }
  </style>


// WEBPACK FOOTER //
// src/components/message/replyMessage.vue